import { useState, useEffect } from 'react'
import { getSettingCertificateGroupAPI } from '../services/setting/certificate'

function UseCertificateGroup() {
  const [data, setData] = useState([])
  useEffect(() => {
    const getData = async () => {
      const resp = await getSettingCertificateGroupAPI()
      if (!resp) return
      if (resp.status) {
        const newData = resp.result.map((d) => {
          return { value: d.paymentCerGroupId, label: d.paymentCerGroup }
        })
        setData(newData)
      } else {
        setData([])
      }
    }
    getData()
  }, [])

  return data
}

export default UseCertificateGroup
